import { group } from '@angular/animations';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css']
})
export class MainComponent implements OnInit {

  pageKey = 'company_main';
  groupKey = 0;

  constructor() { }

  ngOnInit(): void {
  }

  onChangeMenu(groupKey: number, pageKey: string): void {
    this.groupKey = groupKey;
    this.pageKey = pageKey;
  }

  onSelectViewMore(pageInfo: any) {
    this.groupKey = pageInfo.groupKey;
    this.pageKey = pageInfo.pageKey;

    window.scroll(0,0);
  }

  selectedProductType: string;
  onClickGotoMenu(productType: string) {
    this.selectedProductType = productType;
    //this.onChangeMenu(4, 'customer_request');
  }
}
